// Sprint 0.4 — Feedback aptico discreto (Beach Menu PRD v1.1).
//
// Nessun suono (siamo in spiaggia). Solo micro-vibrazione per confermare
// tap critici. Rispetta prefers-reduced-motion e degrada silenziosamente
// su iOS Safari che non supporta l'API.

function _prefersReduced() {
  try {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
  } catch { return false; }
}

function _canVibrate() {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

function _vibrate(pattern) {
  if (_prefersReduced() || !_canVibrate()) return;
  try { navigator.vibrate(pattern); } catch { /* noop */ }
}

/** Impulso singolo breve — aggiunta al carrello, tap primario. */
export function tap() { _vibrate(15); }

/** Doppio impulso — conferma ordine, consegna. */
export function confirm() { _vibrate([25, 40, 25]); }

/** Impulso medio — warning discreto (non usato in Sprint 0). */
export function warn() { _vibrate(40); }

export default { tap, confirm, warn };
